var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex flex-col accordion-item",
      staticStyle: { overflow: "hidden" },
    },
    [
      _c("scheduler-item-row", {
        attrs: {
          backGroundColor: "white",
          weekDates: _vm.weekDates,
          quarterMonths: _vm.quarterMonths,
          weeks: _vm.weeks,
          isDays: _vm.isDays,
          isMonths: _vm.isMonths,
          isWeeks: _vm.isWeeks,
          columnSpan: _vm.columnSpan,
        },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("project-item", {
                  staticClass: "font-bold text-black text-lg",
                  attrs: {
                    isOpened: _vm.isOpened,
                    item: _vm.project.project,
                    isInner: false,
                  },
                  on: { toggleCollapse: _vm.toggleCollapse },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "progress",
            fn: function () {
              return [
                _c(
                  "circle-progress-item",
                  {
                    attrs: {
                      hasData: true,
                      item: _vm.project.project,
                      color: _vm.color,
                      completed: _vm.getCompletedProjectActivitiesActivities(
                        _vm.project.project
                      ),
                      total: _vm.project.project.project_activities.length,
                    },
                  },
                  [
                    _c("span", { staticClass: "inner-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getCompletedProjectActivitiesActivities(
                            _vm.project.project
                          )
                        ) +
                          "/" +
                          _vm._s(_vm.project.project.project_activities.length)
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "progressBar",
            fn: function () {
              return [
                _c("progress-item", {
                  attrs: {
                    item: _vm.project.project,
                    color: _vm.color,
                    progress: _vm.getProjectProgressWidth(_vm.project.project),
                    width: _vm.getProjectProgressItemWidth(_vm.project.project),
                    marginLeft: _vm.getProjectLeftMargin(_vm.project.project),
                    type: "project",
                    currentUser: _vm.currentUser,
                    companyId: _vm.companyId,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._l(
        _vm.project.project.project_activities,
        function (activity, index) {
          return _vm.isOpened
            ? _c("scheduler-item-row", {
                key: activity.id,
                staticClass: "text-base font-semibold",
                attrs: {
                  backGroundColor: "#F2F2F2",
                  weekDates: _vm.weekDates,
                  quarterMonths: _vm.quarterMonths,
                  weeks: _vm.weeks,
                  isDays: _vm.isDays,
                  isMonths: _vm.isMonths,
                  isWeeks: _vm.isWeeks,
                  columnSpan: _vm.columnSpan,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "left",
                      fn: function () {
                        return [
                          _c("activity-item", {
                            attrs: {
                              item: activity,
                              index: index,
                              color: _vm.project.color,
                              currentUser: _vm.currentUser,
                              companyId: _vm.companyId,
                              project: _vm.project,
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "progress",
                      fn: function () {
                        return [
                          _c(
                            "circle-progress-item",
                            {
                              attrs: {
                                hasData: true,
                                item: activity,
                                color: _vm.color,
                                completed:
                                  _vm.getActivityCompletedSteps(activity),
                                total: 10,
                              },
                            },
                            [
                              _c("span", { staticClass: "inner-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getActivityPercentageComplete(activity)
                                  ) + "%"
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "progressBar",
                      fn: function () {
                        return [
                          _c("progress-item", {
                            attrs: {
                              item: activity,
                              project: _vm.project.project,
                              color: _vm.color,
                              progress: _vm.getActivityProgressWidth(activity),
                              width: _vm.getActivityProgressitemWith(activity),
                              marginLeft: _vm.getActivityLeftMargin(activity),
                              type: "activity",
                              currentUser: _vm.currentUser,
                              companyId: _vm.companyId,
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              })
            : _vm._e()
        }
      ),
      _vm.isOpened
        ? _c("scheduler-item-row", {
            attrs: {
              backGroundColor: "#F2F2F2",
              weekDates: _vm.weekDates,
              quarterMonths: _vm.quarterMonths,
              weeks: _vm.weeks,
              isDays: _vm.isDays,
              isMonths: _vm.isMonths,
              isWeeks: _vm.isWeeks,
              columnSpan: _vm.columnSpan,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "left",
                  fn: function () {
                    return [
                      _c("add-activity-item", {
                        attrs: {
                          type: "activity",
                          message: "Add Task",
                          currentUser: _vm.currentUser,
                          companyId: _vm.companyId,
                          project: _vm.project.project,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "progress",
                  fn: function () {
                    return [
                      _c("circle-progress-item", { attrs: { hasData: false } }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1550439858
            ),
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }